export default {
    namespaced: true,
    state: {
        specialNeedsHeader: "",
        specialNeeds: [],
        specialNeedsIds: [],
        specialNeedsEnabled:false
    },
    mutations: {
        setSpecialNeedsData(state, rootState) {
            state.specialNeedsHeader = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty("SpecialNeedsHeader");
                })
                .map(filtered => {
                    return filtered.SpecialNeedsHeader;
                })[0];


            state.specialNeeds = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty("SpecialNeeds");
                })
                .map(filtered => {
                    return filtered.SpecialNeeds;
                })[0];



            if (state.specialNeeds && state.specialNeeds.length > 0) {
                state.specialNeedsEnabled = true;
            }
        },

        toggleSpecialNeedsIds(state, status) {
            if (!state.specialNeedsIds.includes(status)) {
                state.specialNeedsIds.push(status);
            } else if (state.specialNeedsIds.includes(status)) {
                state.specialNeedsIds = state.specialNeedsIds.filter(el => el !== status);
            }
        },

        setSpecialNeedsValuesFromCookie(state, payload) {
            if (payload.types) {
                state.typeIds = payload.types;
            }
        }
    }
}